<script lang="ts">
    import { newNotification, removeNotification } from "../../store"
    import { getLogin, putAccountPassword } from "../../api"
    import { contentFloater, getQueryParam, navigateTo, requireLogin } from "../../helper"
    import MiniLoader from "../widgets/MiniLoader.svelte"
    import Checkbox from "../widgets/Checkbox.svelte"
    import { _ } from "svelte-i18n"
    import { validatePassword } from "../../../../api/hooks/config-client"
    import { initialLocale } from "../../i18n"

    export let lang = "de"
    export let isSetNew = false

    let setToken: string
    if (isSetNew) {
        setToken = getQueryParam("t")
    } else {
        requireLogin()
    }

    let password = ""
    let passwordVerify = ""

    let chpwNotification: NotificationEntry

    let submitLoading = false
    async function submitPW() {
        removeNotification(chpwNotification)

        if (password != passwordVerify) {
            chpwNotification = newNotification({
                class: "warning",
                html: $_("account.passwordMismatch"),
                timeout: 10000,
                removeOnNewLocation: true,
            })
            return
        }
        if (!validatePassword(password)) {
            chpwNotification = newNotification({
                class: "warning",
                html: $_("account.passwordComplexity"),
                timeout: 10000,
                removeOnNewLocation: true,
            })
            return
        }

        submitLoading = true
        try {
            if (isSetNew) {
                await putAccountPassword(null, password, setToken)

                chpwNotification = newNotification({
                    class: "success",
                    html: $_("account.passwordSetSuccess"),
                    timeout: 10000,
                })

                navigateTo("/de/login", { replace: true })
            } else {
                await putAccountPassword((await getLogin())?.tokenData?.id, password)

                chpwNotification = newNotification({
                    class: "success",
                    html: $_("account.passwordChangeSuccess"),
                })

                navigateTo("/")
            }
        } catch (e) {
            chpwNotification = newNotification({
                class: "error",
                html: $_("account.errorOccurred"),
                timeout: 6000,
                removeOnNewLocation: true,
            })

            console.log(e)
        }
        submitLoading = false
    }
</script>

<section id="login" class="section_padding" data-lang="{lang}">
    <div class="container">
        {#if isSetNew}
            <h1>{$_("account.setPasswordTitle")}</h1>
            <p>{$_("account.setPasswordDescription")}</p>
        {:else}
            <h1>{$_("account.changePasswordTitle")}</h1>
        {/if}
        {#if !isSetNew || setToken}
            <form
                on:submit|preventDefault="{() => {
                    submitPW()
                }}"
            >
                <div class="row">
                    <div class="col-md-12">
                        <input
                            type="password"
                            placeholder="{$_('account.newPasswordPlaceholder')}"
                            bind:value="{password}"
                            required
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <input
                            type="password"
                            placeholder="{$_('account.repeatPasswordPlaceholder')}"
                            bind:value="{passwordVerify}"
                            required
                        />
                    </div>
                </div>
                {#if isSetNew}
                    <div class="inputholder">
                        <Checkbox required="{true}" label=" ">
                            <span>
                                {$_("account.termsAndConditionsRead1")}
                                <a href="/{initialLocale}/nutzungsbedingungen" use:contentFloater
                                    >{$_("account.termsAndConditions")}</a
                                >
                                {$_("account.termsAndConditionsRead2")}</span
                            ></Checkbox
                        >
                    </div>
                {/if}
                <div class="row">
                    <div class="col-md-6 flexstart"></div>
                    <div class="col-md-6 flexend">
                        {#if submitLoading}
                            <MiniLoader />
                        {:else}
                            <button class="btn" type="submit">{$_("account.submitButton")}</button>
                        {/if}
                    </div>
                </div>
            </form>
        {:else}
            <b>{$_("account.accessDenied")}</b>
        {/if}
    </div>
</section>
